import React, { useState } from 'react';
//import { useHistory } from "react-router-dom";
import Menu from './components/Menu';
import { Container, Row, Col, Button, Modal, ModalBody, ModalFooter, Input, Navbar, NavbarToggler, NavbarBrand } from 'reactstrap';
import axios from 'axios';
import helpers from "./helpers/Utilities";
import constants from './helpers/Constants';
import './App.css';

function Cadastro2() {

    const [menu, setMenu] = useState(false);
    const toggleMenu = () => { setMenu(!menu); };

    const cpf = JSON.parse(localStorage.getItem('usuario_logado')).cpf;
    const [senha, setSenha] = useState('');
    const [senha2, setSenha2] = useState('');

    const [showMsg, setShowMsg] = useState(false);
    const [showMsgOK, setShowMsgOK] = useState(false);
    const [msg, setMsg] = useState('');
    const toggleMsg = () => setShowMsg(!showMsg);
    const toggleMsgOK = () => setShowMsgOK(!showMsgOK);

    const [validated, setValidated] = useState(false);

    //const history = useHistory();

    const handleContinuar = () => {

        if (helpers.isEmpty(senha) || helpers.isEmpty(senha2) || senha.trim().length < 6) {
            setMsg('A nova senha deve ter pelo menos 6 caracteres.');
            toggleMsg();
            setValidated(true);
        }
        else if (senha != senha2) {
            setMsg('As senhas não conferem.');
            toggleMsg();
            setValidated(true);
        }
        else {
            setValidated(false);
            let cmd = `UPDATE associado SET `;
            cmd += `  senha='${helpers.sha1(senha)}'`;
            cmd += `, senha_atualizada_em=NOW()`;
            cmd += ` WHERE cpf = '${cpf}'`;

            axios({
                method: 'post',
                url: constants.APIURLExec,
                headers: {
                    'APITOKEN': constants.APIToken
                },
                data: {
                    cmd: cmd
                }
            })
                .then(function (response) {
                    console.log(response);
                    if (response.data.ok) {
                        setShowMsgOK(true);
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    };

    return (
        <div id="wrapper" className={`d-flex ${menu ? 'toggled' : ''}`}>
            <Menu />
            <div id="page-content-wrapper">
                <Navbar className="bg-azul" dark>
                    <NavbarToggler onClick={toggleMenu} className="mr-2 border-0" />
                    <NavbarBrand className='mr-auto'>Dados Pessoais</NavbarBrand>
                </Navbar>
                <Container className="mb-5">
                    <Modal isOpen={showMsg}>
                        <ModalBody>
                            {msg}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={toggleMsg}>OK</Button>
                        </ModalFooter>
                    </Modal>
                    <Modal isOpen={showMsgOK}>
                        <ModalBody>
                            Dados alterados com sucesso.
                        </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={toggleMsgOK}>OK</Button>
                        </ModalFooter>
                    </Modal>
                    <Row>
                        <Col className="mt-3">
                            <Input className={`form-control ${(validated && (helpers.isEmpty(senha) || senha.trim().length < 6) ? 'is-invalid' : '')}`} type="password" placeholder="Defina uma senha" value={senha} onChange={(e) => setSenha(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3">
                            <Input className={`form-control ${(validated && (helpers.isEmpty(senha2) || senha2.trim().length < 6 || senha !== senha2) ? 'is-invalid' : '')}`} type="password" placeholder="Repita a senha" value={senha2} onChange={(e) => setSenha2(e.target.value)} ></Input>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="mt-3 mb-5">
                            <Button onClick={handleContinuar} className="btn btn-block btn-lg btn-primary btn-azul">SALVAR</Button>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default Cadastro2;
